var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 2C6.8 2 2 6.8 2 12.8C2 18.8 6.8 23.6 12.8 23.6C18.8 23.6 23.6 18.8 23.6 12.8C23.6 6.8 18.7 2 12.8 2ZM16.6 15.6L19.7 18.7C19.4 19.1 19 19.4 18.7 19.7L14.6 15.6H3.7C3.7 15.3 4 15.1 4.2 15.1C4.4 15.1 4.5 15.2 4.6 15.3C4.8 14.9 5.1 14.6 5.6 14.6C5.8 14.6 5.9 14.6 6 14.7C6.2 13.5 7.2 12.5 8.5 12.5C8.5 11.7 8.8 11 9.2 10.4L5.8 6.8C6.1 6.4 6.5 6.1 6.8 5.8L10.4 9.4C11 9.1 11.6 8.9 12.2 8.9C13.7 8.9 14.9 9.8 15.5 11.1C16.9 11.1 18.1 12.2 18.4 13.5C18.5 13.5 18.6 13.5 18.8 13.5C19.7 13.5 20.4 14.1 20.6 14.9C20.8 14.8 21 14.7 21.2 14.7C21.7 14.7 22.1 15.1 22.1 15.6H16.6Z",
    fill: "#FA1439"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmissions);
export default __webpack_public_path__ + "static/media/emissions.e837425dc1a24e1c9a0916c6a7fd7305.svg";
export { ForwardRef as ReactComponent };